import React from 'react';
import styled from 'styled-components';
import { FiPercent } from 'react-icons/fi';

const BannerWrapper = styled.div`
  background: #ffe0f0;
  border: 1.5px solid #ffb3d9;
  border-radius: 10px;
  padding: 22px 32px 18px 32px;
  margin: 32px 0 28px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  box-shadow: 0 2px 8px rgba(218,1,92,0.04);
  direction: rtl;
  @media (max-width: 600px) {
    padding: 16px 8px 12px 8px;
    font-size: 1rem;
  }
`;

const BannerText = styled.div`
  font-size: 1.25rem;
  color: #b80149;
  font-weight: 600;
  span {
    color: #DA015C;
    font-weight: 800;
  }
`;

const PromoBanner: React.FC = () => (
  <BannerWrapper>
    <FiPercent size={28} color="#DA015C" />
    <BannerText>
      سجّل الآن واحصل على <span>خصم 50%</span> على عمولة الشهر الأول!<br />
      <span style={{ fontWeight: 400, color: '#b80149', fontSize: '1rem' }}>
        التسجيل المبكر ينتهي في 15 يونيو.
      </span>
    </BannerText>
  </BannerWrapper>
);

export default PromoBanner;
